import React, { useState, useEffect } from 'react';
import { Box, Typography, makeStyles, Button, useTheme, useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../redux/typedHooks';
import charlotteSins from '../../components/Main/Landing/images/charlotteSins.png';
import lillyBell from '../../components/Main/Landing/images/LillyBell.png';
import charlieForde from '../../components/Main/Landing/images/CharlieForde.png';
import savannahNguyen from '../../components/Main/Landing/images/SavannahNguyen.png';
import jennyWilson from '../../components/Main/Landing/images/JennyWilson.png';
import dianneRussell from '../../components/Main/Landing/images/DianneRussell.png';
import leslieAlexander from '../../components/Main/Landing/images/LeslieAlexander.png';
import sableNoir from '../../components/Main/Landing/images/SableNoir.png';
import romySinclair from '../../components/Main/Landing/images/RomySinclair.png';
import savannahCover from './images/Savannah_Nguyen_cover.jpg';
import charlieCover from './images/Charlie_forde_cover.jpg';

const VerifiedBadge = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.999 1.547L7.319 0L5.833 2.575H2.716V5.752L0 7.32L1.547 10L0 12.6795L2.716 14.248V17.2005H5.7035L7.319 20L9.999 18.453L12.679 20L14.295 17.2H17.376V14.195L20 12.6795L18.4525 10L20 7.3205L17.376 5.8055V2.5755H14.1665L12.679 0L9.999 1.547ZM13.7065 7.1595L14.8335 8.303L9.1185 14.053L5.701 10.588L6.823 9.459L9.1165 11.7495L13.7065 7.1595Z" fill="#FE5A97" />
  </svg>
);

export const GENESIS_CREATORS = [
  {
    image: charlotteSins,
    name: "Charlotte Sins",
    username: "charolette",
    badge: "Sensual Travel",
    description: "Fine art glamour & behind-the-scenes. New sets every Friday, custom requests open.",
    posts: "312",
    subscribers: "18.4k"
  },
  {
    image: lillyBell,
    name: "Lilly Bell",
    username: "lilly",
    badge: "Cosplay",
    description: "Exclusive photos, intimate moments, and premium content curated for dedicated subscribers.",
    posts: "573",
    subscribers: "28.4k"
  },
  {
    image: charlieForde,
    name: "Charlie Forde",
    username: "charlie",
    badge: "Creative",
    description: "Go beyond the highlights with authentic moments, exclusive collections, and updates released every week.",
    posts: "865",
    subscribers: "30.1k"
  },
  {
    image: savannahNguyen,
    name: "Savannah Nguyen",
    username: "savannah",
    badge: "Lifestyle",
    description: "Exclusive photos, behind-the-scenes moments, and premium content shared regularly for subscribers.",
    posts: "968",
    subscribers: "28.9k"
  },
  {
    image: jennyWilson,
    name: "Jenny Wilson",
    username: "jenny",
    badge: "Playful",
    description: "Unlock a more personal side with exclusive galleries, private updates, and members-only content.",
    posts: "851",
    subscribers: "300.1k"
  },
  {
    image: dianneRussell,
    name: "Dianne Russell",
    username: "dianne",
    badge: "Sensual",
    description: "Discover premium lifestyle content, intimate photography, and exclusive releases.",
    posts: "534",
    subscribers: "11.1k"
  },
  {
    image: leslieAlexander,
    name: "Leslie Alexander",
    username: "leslie",
    badge: "Sensual",
    description: "Fresh content every week featuring exclusive shoots, personal updates, and subscriber-only experiences.",
    posts: "142",
    subscribers: "8.10k"
  },
  {
    image: sableNoir,
    name: "Sable Noir",
    username: "sable",
    badge: "Solo",
    description: "An exclusive community for premium photo sets, authentic moments, and special content.",
    posts: "645",
    subscribers: "12.9k"
  },
  {
    image: romySinclair,
    name: "Romy Sinclair",
    username: "romy",
    badge: "Playful",
    description: "From glamorous editorials to candid behind-the-scenes moments.",
    posts: "131",
    subscribers: "10.91k"
  }
];

const TOP_PERFORMERS = [
  {
    coverImage: savannahCover,
    avatar: savannahNguyen,
    name: "Savannah Nguyen",
    username: "savannah",
    handle: "@Savannah",
    description: "Exclusive photos, behind-the-scenes moments, and premium content shared regularly for subscribers",
    tags: ["Playful", "Lifestyle", "Travel"],
    posts: "968",
    followers: "28.9k"
  },
  {
    coverImage: charlieCover,
    coverPosition: "center 33%",
    avatar: charlieForde,
    name: "Charlie Forde",
    username: "charlie",
    handle: "@charlieforde",
    description: "Go beyond the highlights with authentic moments, exclusive collections, and updates released every week.",
    tags: ["Creative", "Sensual", "Cosplay"],
    posts: "941",
    followers: "23.22k"
  },
  {
    coverImage: jennyWilson,
    coverPosition: "center 22%",
    avatar: jennyWilson,
    name: "Jenny Wilson",
    username: "jenny",
    handle: "@jennywilson",
    description: "Unlock a more personal side with exclusive galleries, private updates, and members-only content.",
    tags: ["Cosplay", "Sensual", "Travel"],
    posts: "851",
    followers: "300.1k"
  }
];

const useStyles = makeStyles((theme) => ({
  rosterSection: {
    maxWidth: '1314px',
    margin: '0 auto',
    padding: '0 21px',
    textAlign: 'center',
    boxSizing: 'content-box',
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
      boxSizing: 'border-box',
    }
  },
  rosterSection2: {
    maxWidth: '1314px',
    margin: '0 auto',
    padding: '0 21px',
    textAlign: 'center',
    boxSizing: 'content-box',
    marginTop: "80px",
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
      boxSizing: 'border-box',
      marginTop: "30px"
    }
  },
  rosterHeader: {
    marginBottom: '60px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '32px',
    }
  },
  rosterHeader1: {
    marginBottom: '60px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '40px',
    }
  },
  rosterTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
    }
  },
  rosterSubtitle: {
    fontSize: '18px',
    fontWeight: 200,
    color: '#FFFFFF',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: 1.6,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
    }
  },
  collectionGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
    marginBottom: '40px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      overflowX: 'auto',
      scrollSnapType: 'x mandatory',
      paddingBottom: '16px',
      marginBottom: '24px',
      gap: '24px',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '-ms-overflow-style': 'none',
      'scrollbar-width': 'none',
    }
  },
  topPerformersGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
    marginBottom: '40px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '24px',
    }
  },
  collectionCard: {
    backgroundColor: '#1F1F1F',
    borderRadius: '16px',
    overflow: 'hidden',
    position: 'relative',
    height: '527px',
    maxWidth: '418px',
    width: '100%',
    margin: '0 auto',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      height: '420px',
      minWidth: '280px',
      maxWidth: 'none',
      scrollSnapAlign: 'start',
      flexShrink: 0,
    },
    '&:hover $collectionImage': {
      transform: 'scale(1.08)',
    },
    '&:hover $cardOverlay': {
      transform: 'translateY(0)',
    },
    '&:hover $cardOverlay::before': {
      opacity: 1,
    },
    '&:hover $viewProfileBtn': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  viewProfileBtnActive: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex !important',
      opacity: '1 !important',
      transform: 'translateY(0) !important',
      pointerEvents: 'auto',
    },
  },
  collectionImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
  },
  cardOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '30px 20px 20px',
    background: 'linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.6) 45%, rgba(0,0,0,0.1) 75%, transparent 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
    transform: 'translateY(58px)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-60px',
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to top, rgba(0,0,0,0.98) 0%, rgba(0,0,0,0.88) 55%, rgba(0,0,0,0.35) 85%, transparent 100%)',
      opacity: 0,
      transition: 'opacity 0.4s ease',
      zIndex: 0,
      pointerEvents: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      transform: 'none',
      padding: '24px 20px 20px',
    }
  },
  cardName: {
    fontSize: '18px',
    fontWeight: 600,
    fontFamily: '"Roboto", sans-serif',
    color: '#FF4D8C',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '10px',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    }
  },
  cardBadge: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: '"Roboto", sans-serif',
    color: '#D7A7B9',
    border: '1px solid rgba(215, 167, 185, 0.5)',
    borderRadius: '20px',
    padding: '4px 12px',
    marginBottom: '14px',
    textTransform: 'none',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      fontWeight: 400,
    }
  },
  cardDesc: {
    fontSize: '16px',
    fontWeight: 200,
    fontFamily: '"Roboto", sans-serif',
    color: '#FFFFFF',
    lineHeight: 1.5,
    marginBottom: '20px',
    textAlign: 'left',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: "21px",
    }
  },
  cardStats: {
    display: 'flex',
    gap: '40px',
    width: '100%',
    position: 'relative',
    zIndex: 1,
  },
  statValue: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#FFFFFF',
    lineHeight: 1,
    fontFamily: '"Roboto", sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    }
  },
  statLabel: {
    fontSize: '18px',
    fontWeight: 200,
    color: '#FFFFFF',
    marginTop: '6px',
    fontFamily: '"Roboto", sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: "21px",
    }
  },
  viewProfileBtn: {
    width: '100%',
    height: '42px',
    marginTop: '16px',
    backgroundColor: '#FD3C84',
    color: '#111111',
    fontWeight: 700,
    fontSize: '14px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transform: 'translateY(10px)',
    transition: 'opacity 0.35s ease, transform 0.35s ease, background-color 0.2s ease',
    textTransform: 'none',
    fontFamily: '"Roboto", sans-serif',
    position: 'relative',
    zIndex: 1,
    '&:hover': {
      backgroundColor: '#ff5a97',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  loadMoreBtn: {
    border: '1px solid rgba(255, 255, 255, 0.3)',
    color: '#fff',
    borderRadius: '8px',
    padding: '6px 30px',
    textTransform: 'none',
    fontSize: '16px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      padding: '2px 30px',
      fontSize: '14px',
    }
  },
  topPerformerCard: {
    background:
      'linear-gradient(#0F0F0F, #0F0F0F50) padding-box, linear-gradient(90deg, #CE949C50 0%, #E6B1BD50 17.31%, #FFD0E150 36.06%, #CE949C50 100%) border-box',
    border: '0.2px solid transparent',
    borderRadius: '12px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
    maxWidth: '418px',
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
    }
  },
  tpCover: {
    width: '100%',
    height: '140px',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      height: '100px',
    }
  },
  tpAvatar: {
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    border: '2px solid #FD3C84',
    marginTop: '-60px',
    objectFit: 'cover',
    position: 'relative',
    zIndex: 2,
    backgroundColor: '#111',
    [theme.breakpoints.down('sm')]: {
      width: '80px',
      height: '80px',
      marginTop: '-40px',
    }
  },
  tpContent: {
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    flex: 1
  },
  tpName: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    fontWeight: 600,
    color: '#FD3C84',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '2px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    }
  },
  tpHandle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    color: '#747474',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      fontWeight: 200,
      marginBottom: '10px',
    }
  },
  tpDesc: {
    fontSize: '18px',
    color: '#FFFFFF',
    fontWeight: 200,
    lineHeight: "27px",
    marginBottom: '16px',
    maxWidth: '330px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: "24px",
      maxWidth: "300px",
      fontWeight: 200
    }
  },
  tpTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'center',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '8px',
    }
  },
  tpTag: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    height: '30px',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    padding: '3px 20px',
    borderRadius: '50px',
    background: 'linear-gradient(90deg, #CE949C 0%, #E6B1BD 17.31%, #FFD0E1 36.06%, #CE949C 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '50px',
      padding: '1px',
      background: 'linear-gradient(90deg, #CE949C 0%, #E6B1BD 17.31%, #FFD0E1 36.06%, #CE949C 100%)',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'destination-out',
      maskComposite: 'exclude',
      pointerEvents: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      border: 'none',
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '100%',
      letterSpacing: '0%',
      padding: '8px 20px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }
  },
  tpStats: {
    display: 'flex',
    width: 'calc(100% - 40px)',
    margin: '0 20px 20px',
    backgroundColor: '#070707',
    borderRadius: '8px',
    border: '1px solid #1F1F1F',
  },
  tpStatBox: {
    flex: 1,
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    '&:first-child::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: '70%',
      width: '1px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
}));

export const GenesisFoundingRoster = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showAll, setShowAll] = useState(false);
  const [activeCreator, setActiveCreator] = useState<string | null>(null);

  const currentUser = useAppSelector(state => state.user.currentUser);
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");
  const isLoggedIn = Boolean(currentUser || token);

  const visibleCreators = isMobile || showAll ? GENESIS_CREATORS : GENESIS_CREATORS.slice(0, 6);

  useEffect(() => {
    if (!isMobile || !activeCreator) return;
    const handleOutsideClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(`.${classes.collectionCard}`)) {
        setActiveCreator(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isMobile, activeCreator, classes.collectionCard]);

  const handleViewProfile = (creator: (typeof GENESIS_CREATORS)[number], e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    const username = creator.username || creator.name.toLowerCase().replace(/\s+/g, '');
    if (isLoggedIn) {
      history.push(`/${username}`);
    } else {
      history.push(`/login?username=${encodeURIComponent(username)}`);
    }
  };

  const handleCardClick = (creator: (typeof GENESIS_CREATORS)[number]) => {
    if (isMobile) {
      // Tapping the card only reveals/toggles the View Profile button; it never navigates
      setActiveCreator((prev) => (prev === creator.name ? null : creator.name));
    }
  };

  return (
    <Box className={classes.rosterSection}>
      <Box className={classes.rosterHeader1}>
        <Typography className={classes.rosterTitle}>
          The Founding Roster
        </Typography>
        <Typography className={classes.rosterSubtitle}>
          Hand-selected for craft, consistency, and category-defining content. Each Genesis Creator carries a permanent founding number — never reissued.
        </Typography>
      </Box>

      <Box className={classes.collectionGrid}>
        {visibleCreators.map((creator, index) => {
          const isActive = activeCreator === creator.name;
          return (
            <Box
              key={creator.name || index}
              className={classes.collectionCard}
              onClick={() => handleCardClick(creator)}
            >
              <img src={creator.image} alt={creator.name} className={classes.collectionImage} />
              <Box className={classes.cardOverlay}>
                <Typography className={classes.cardName}>
                  {creator.name}
                  <VerifiedBadge />
                </Typography>
                <Typography className={classes.cardBadge}>
                  {creator.badge}
                </Typography>
                <Typography className={classes.cardDesc}>
                  {creator.description}
                </Typography>
                <Box className={classes.cardStats}>
                  <Box>
                    <Typography className={classes.statValue}>{creator.posts}</Typography>
                    <Typography className={classes.statLabel}>Posts</Typography>
                  </Box>
                  <Box>
                    <Typography className={classes.statValue}>{creator.subscribers}</Typography>
                    <Typography className={classes.statLabel}>Subscribers</Typography>
                  </Box>
                </Box>
                <button
                  className={`${classes.viewProfileBtn} ${isActive ? classes.viewProfileBtnActive : ''}`}
                  onClick={(e) => handleViewProfile(creator, e)}
                >
                  View Profile
                </button>
              </Box>
            </Box>
          );
        })}
      </Box>

      {!showAll && (
        <Button className={classes.loadMoreBtn} onClick={() => setShowAll(true)}>
          Load More
        </Button>
      )}
    </Box>
  );
};

export const GenesisTopPerformers = () => {
  const classes = useStyles();
  const history = useHistory();

  const currentUser = useAppSelector(state => state.user.currentUser);
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");
  const isLoggedIn = Boolean(currentUser || token);

  return (
    <Box className={classes.rosterSection2}>
      <Box className={classes.rosterHeader}>
        <Typography className={classes.rosterTitle}>
          Our Top Performers
        </Typography>
        <Typography className={classes.rosterSubtitle}>
          Hand-selected for craft, consistency, and category-defining content. Each Genesis Creator carries a permanent founding number — never reissued.
        </Typography>
      </Box>

      <Box className={classes.topPerformersGrid}>
        {TOP_PERFORMERS.map((perf, idx) => (
          <Box
            key={idx}
            className={classes.topPerformerCard}>
            <img
              src={perf.coverImage}
              alt="Cover"
              className={classes.tpCover}
              style={perf.coverPosition ? { objectPosition: perf.coverPosition } : undefined}
            />
            <img src={perf.avatar} alt={perf.name} className={classes.tpAvatar} />

            <Box className={classes.tpContent}>
              <Typography className={classes.tpName}
                style={{ cursor: 'pointer' }} onClick={() => {
                  const username = perf.username;
                  if (isLoggedIn) {
                    history.push(`/${username}`);
                  } else {
                    history.push(`/login?username=${encodeURIComponent(username)}`);
                  }
                }}>
                {perf.name}
                <VerifiedBadge />
              </Typography>
              <Typography className={classes.tpHandle}>
                {perf.handle}
              </Typography>
              <Typography className={classes.tpDesc}>
                {perf.description}
              </Typography>
              <Box className={classes.tpTags}>
                {perf.tags.map(tag => (
                  <Typography key={tag} className={classes.tpTag}>
                    {tag}
                  </Typography>
                ))}
              </Box>
            </Box>

            <Box className={classes.tpStats}>
              <Box className={classes.tpStatBox}>
                <Typography className={classes.statValue}>{perf.posts}</Typography>
                <Typography className={classes.statLabel}>Posts</Typography>
              </Box>
              <Box className={classes.tpStatBox}>
                <Typography className={classes.statValue}>{perf.followers}</Typography>
                <Typography className={classes.statLabel}>Followers</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export const GenesisRosters = () => {
  return (
    <>
      <GenesisFoundingRoster />
      <GenesisTopPerformers />
    </>
  );
};
